import React from 'react'
import ReactMarkdown from 'react-markdown'
import PropTypes from 'prop-types'
import Video from '../Video/Video'
import "./TextImage.scss"

const TextImage = ({ data }) => {
  return (
    <div className="my-3 my-md-5 container text-image-container">
      {data.activateVideo ? (
        <div className="h-100 row rounded overflow-hidden">
          <div className="col-12 col-md-6 publication-video">
            <Video videoComponent={data} />
          </div>
          <div className=" col-12 col-md-6 publication-content">
            <div className="flex-grow-1 d-flex align-items-center justify-content-center">
              <ReactMarkdown
                renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
                rehypePlugins={false}
                children={data.content}
                className="markdown-format"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="h-100 row rounded overflow-hidden">
          <div className="col-12 col-md-6">
           <div className=" d-flex align-items-center justify-content-center">
            <img
              src={data.image?.url || ''}
              alt={data.imageName || ''}
              className="publication-image"
            />
          </div> 
          </div>
          <div className=" col-12 col-md-6 publication-content">
            <div className="flex-grow-1 d-flex align-items-center justify-content-center">
              <ReactMarkdown
                renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
                rehypePlugins={false}
                children={data.content}
                className="markdown-format"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TextImage

TextImage.propTypes = {
  data: PropTypes.object.isRequired
}
